import { render, staticRenderFns } from "./site-add.vue?vue&type=template&id=620adc9d&scoped=true"
import script from "./site-add.vue?vue&type=script&lang=js"
export * from "./site-add.vue?vue&type=script&lang=js"
import style0 from "./site-add.vue?vue&type=style&index=0&id=620adc9d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620adc9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620adc9d')) {
      api.createRecord('620adc9d', component.options)
    } else {
      api.reload('620adc9d', component.options)
    }
    module.hot.accept("./site-add.vue?vue&type=template&id=620adc9d&scoped=true", function () {
      api.rerender('620adc9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/site/site-add.vue"
export default component.exports